import React from "react";

class Notifications extends React.Component {
  render() {
    return <div>Notifications</div>;
  }
}
export default Notifications;
